import * as ng from 'angular';
import { StateService } from '@uirouter/angularjs';

export class ExperienceListController {
   static $inject = ['$state', 'experiencesService', 'loader', 'titleService', 'session'];

   experiences:any;

   constructor(
      private $state:StateService,
      private experiencesService,
      private loader,
      titleService,
      private session
   ) {
      titleService.setTitle('Experience Editor');
      this.getList();
   }

   private getList() {
      this.loader.showSpinner();
      this.experiencesService.list(this.session.getCampaign().id)
         .then((experiences) => {
            this.experiences = experiences;
         })
         .finally(() => this.loader.hide());
   }

   newAppExperience(deviceType:string) {
      this.$state.go('campaign.experienceEdit', {slug: deviceType});
   }
}

ng.module('e360')
   .controller('ExperienceListController', ExperienceListController);
